module.exports = __webpack_public_path__ + "img/img.f7719db5.png";